<template>
    <div class="p-24">
        <frontend-practice-quiz
            :practice-quizzes="practiceQuizzes"
        ></frontend-practice-quiz>
    </div>
</template>

<script>
import FrontendPracticeQuiz from "@/Components/FrontendPracticeQuiz";

export default {
    name: "FeaturesPracticeQuiz",
    components: { FrontendPracticeQuiz },
    props: {
        practiceQuizzes: {
            type: Array,
            default: [],
        },
    },
};
</script>

<style scoped></style>
